import { forwardRef } from 'react';
import type { PropsWithoutRef, Ref } from 'react';

import type { BaseProps, ForwardRefForwardPropsComponent, NoChildrenProp } from '../../types';
import { StyledButtonLink } from '../Button';
import NoValue from '../NoValue/NoValue';

export interface EmailDisplayProps extends BaseProps, NoChildrenProp {
  /** Email address, no 'mailto:' scheme */
  value?: string;
  /** The text to be displayed. */
  displayText?: string;
  /**
   * Controls styling of the field.
   * @default 'link'
   */
  variant?: 'link' | 'text';
  /** Ref for the wrapping element. */
  ref?: Ref<HTMLAnchorElement | HTMLSpanElement>;
}

const EmailDisplay: ForwardRefForwardPropsComponent<EmailDisplayProps> = forwardRef(
  function EmailDisplay(
    { value, displayText, variant = 'link', ...restProps }: PropsWithoutRef<EmailDisplayProps>,
    ref: EmailDisplayProps['ref']
  ) {
    const displayValue = value ? displayText || value : <NoValue />;
    return variant === 'text' || !value ? (
      <span ref={ref} {...restProps}>
        {displayValue}
      </span>
    ) : (
      <StyledButtonLink
        {...restProps}
        variant='link'
        ref={ref as Ref<HTMLAnchorElement>}
        href={`mailto:${value}`}
      >
        {displayValue}
      </StyledButtonLink>
    );
  }
);

export default EmailDisplay;
